import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GuardarCarpetaService {

  private endpoint = `${environment.ApiConecta}perfilamiento/creacion-carpeta`;

  constructor(
    private http: HttpClient
  ) { }

  saveCarpeta(numeroSolicitud: string): Observable<any> {
    return this.http.post<string>(this.endpoint, { numeroSolicitud });
  }

  flagCarpeta(carpeta: number) {
    return this.http.post<number>(`${environment.ApiConecta}buscarCarpeta`, {carpeta});
  }
}
